import { FILE_TYPE_BADGES, getFileBadge } from 'components/UploadHub/fileTypeBadges';

const escapeHtml = (value = '') => {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
};

export interface EmailAttachment {
  url: string;
  fileName: string;
  contentType?: string;
}

const REMOVE_CELL_HTML =
  `<td class="email-attachment-remove-cell" style="padding:3px 12px 3px 0;width:20px;text-align:right; border: none;">` +
  `<a href="#" class="email-attachment-remove" contenteditable="false" style="color:#00122b;text-decoration:none;cursor:pointer;font-size:24px;">&times;</a>` +
  `</td>`;

interface Badge {
  label: string;
  color: string;
}

// AE: Outlook desktop (Word engine) ignores table borders, table margins and sizing on inline elements, so the border sits on a cell, spacing is a spacer row and the badge is a cell.
const buildAttachmentItemHtml = ({ url, fileName, badge }: { url: string; fileName: string; badge: Badge }) =>
  `<table class="email-attachment-item" contenteditable="false" cellpadding="0" cellspacing="0" border="0" style="border-collapse:separate;border:none;max-width:320px;width:100%;">` +
  `<tr><td bgcolor="#f9f9f9" style="padding:0;border:1px solid #ccd0d5;background-color:#f9f9f9;">` +
  `<table cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse:collapse;border:none;width:100%;table-layout:fixed;">` +
  `<tr class="email-attachment-row">` +
  `<td style="padding:10px 0 10px 12px;width:24px; border: none;">` +
  `<table cellpadding="0" cellspacing="0" border="0" style="border-collapse:separate;border:none;"><tr>` +
  `<td class="email-attachment-badge" height="24" align="center" valign="middle" bgcolor="${badge.color}" style="width:18px;height:24px;padding:0 3px;white-space:nowrap;border:none;border-radius:4px;background-color:${badge.color};color:#fff;font-family:Arial,sans-serif;font-size:8px;line-height:24px;font-weight:bold;text-align:center;mso-line-height-rule:exactly;">${badge.label}</td>` +
  `</tr></table>` +
  `</td>` +
  `<td style="padding:8px 10px;overflow:hidden; border: none;">` +
  `<a href="${url}" target="_blank" rel="noreferrer" style="color:#00122b;text-decoration:none;line-height: 1.3;display:block;width:100%;overflow:hidden; white-space: nowrap; text-overflow: ellipsis;"><span>${escapeHtml(fileName)}</span></a>` +
  `</td>` +
  REMOVE_CELL_HTML +
  `</tr>` +
  `</table>` +
  `</td></tr>` +
  `<tr><td height="8" style="height:8px;padding:0;border:none;font-size:8px;line-height:8px;mso-line-height-rule:exactly;">&nbsp;</td></tr>` +
  `</table>`;

export const buildEmailAttachmentHtml = (files: EmailAttachment[] = []) => {
  if (files.length === 0) return '';
  const attachmentsHtml = files
    .map(({ url, fileName, contentType }) =>
      buildAttachmentItemHtml({ url, fileName, badge: getFileBadge({ contentType }) })
    )
    .join('');
  return attachmentsHtml + '<p><br></p>';
};

export const stripEmailAttachmentControls = (html = '') => {
  if (!html) return html;
  const div = document.createElement('div');
  div.innerHTML = html;
  div.querySelectorAll('.email-attachment-remove-cell').forEach((cell) => cell.remove());
  return div.innerHTML;
};

export const normalizeEmailAttachments = (root: HTMLElement) => {
  root.querySelectorAll('.email-attachment-item').forEach((item) => {
    if (item.querySelector('.email-attachment-badge') && item.querySelector('.email-attachment-remove-cell')) return;
    const link = item.querySelector('a[href]:not(.email-attachment-remove)');
    if (!link) return;
    const label =
      (item.querySelector('.email-attachment-badge') ?? item.querySelector('span'))?.textContent?.trim() || 'FILE';
    const color = Object.values(FILE_TYPE_BADGES).find((badge) => badge.label === label)?.color ?? '#00122b';
    item.outerHTML = buildAttachmentItemHtml({
      url: link.getAttribute('href') ?? '',
      fileName: link.textContent ?? '',
      badge: { label, color },
    });
  });
};
